import { Icon } from "@blueprintjs/core"
import React, { useMemo, useState } from "react"
import CustomInfoWindow from "components/Organisms/map/CustomInfoWindow"
import OrderLabel from "./OrderLabel"
import OrderMarker from "./OrderMarker"

const OrderMarkers = ({
  orders,
  children = undefined,
  showSerial = undefined,
}) => {
  const [hovered, setHovered] = useState<any>({})
  // extract the hovered address for ease of access
  const hoveredAddr = hovered?.orders?.[0]?.shippingAddress

  const ords = useMemo(
    () =>
      orders &&
      orders?.reduce?.((p, o, index) => {
        const adr = o?.shippingAddress
        const location = JSON.stringify({
          lat: adr.latitude,
          lng: adr.longitude,
        })
        const order = { ...o, index }
        return {
          ...p,
          [location]:
            p[location]?.length > 0 ? p[location]?.concat(order) : [order],
        }
      }, {}),
    [orders]
  )

  return (
    <>
      {ords &&
        Object.keys(ords)?.map?.((location, index) => {
          const orders = ords?.[location]
          return (
            <OrderMarker
              showSerial={showSerial}
              onMouseOver={() =>
                setHovered({ orders, location: JSON.parse(location) })
              }
              onMouseOut={() => setHovered({})}
              key={location}
              location={JSON.parse(location)}
              // serial={index + 1}
              orders={orders}
            />
          )
        })}

      <CustomInfoWindow position={hovered?.location}>
        <div>
          {hovered?.orders?.map(o => {
            return <OrderLabel key={o?.id} order={o} />
          })}
          <p className="mb-1">
            <Icon icon="locate" />{" "}
            {hoveredAddr?.address ??
              `${hoveredAddr?.taluka}, ${hoveredAddr?.village}`}
          </p>
        </div>
      </CustomInfoWindow>
      {children}
    </>
  )
}

export default OrderMarkers
